export default (animationsLoaders) => (animationId, containerId) => ({
  init() {
    this.loadAnimationById(animationId, containerId)
  },
  
  loadAnimationById(animationId, containerId) {
    const animationLoader = animationsLoaders[animationId]
    if (!animationLoader) {
      console.error(`Animation loader "${animationId}" not found`)
      return
    }

    // Element ID is optionally passed to not hardcode it within loaders
    animationLoader(containerId || animationId)
  },
})
